import DashboardLayout from "components/Layouts/DashboardLayout";
import TasksManagerView from "./TasksManagerView";

const TasksManagerViewContainer = () => {
	return (
		<DashboardLayout>
			<TasksManagerView />
		</DashboardLayout>
	);
};

export default TasksManagerViewContainer;
